import ImageRoundedIcon from '@mui/icons-material/ImageRounded'
import { FilePicker } from '../../Common/FilePicker'
import { useNls } from '../../../nls/nlsProvider'

export interface ImageUploadPaneProps {
  onFiles: (files: File[]) => void
}

export const ImageUploadPane = ({ onFiles }: ImageUploadPaneProps) => {
  const { t } = useNls()

  return (
    <div className="ctxPane ctxPane--image">
      <div className="ctxPane__ingestHero">
        <ImageRoundedIcon style={{ fontSize: 36, opacity: 0.5 }} />
        <h4>{t('NLSAiContextPickerCategoryImage')}</h4>
        <p>Upload images for multimodal vision analysis. Supports JPG, PNG, GIF, WEBP.</p>
        <p className="ctxPane__costNote">+15 Cr fixed per image (vision model overhead)</p>
      </div>

      <FilePicker
        accept="image/*"
        multiple
        maxBytes={Number.MAX_SAFE_INTEGER}
        onFiles={onFiles}
      />
    </div>
  )
}
